const { makeActionTypes } = require('../utils/redux-helpers');

module.exports = makeActionTypes({
    ALERTS:             require('./alerts'            ),
    CONNECTIVITY:       require('./connectivity'      ),
    APP:                require('./app'               ),
    AUTH:               require('./auth'              ),
    SIGNUP:             require('./signup'            ),
    COMMUNICATION:      require('./communication'     ),
    DATA_FETCHING:      require('./data-fetching'     ),
    NOTIFICATIONS:      require('./notifications'     ),
    PROFILE_MANAGEMENT: require('./profile-management'),
    CHATS:              require('./chats'             ),
    CLASSES:            require('./classes'           ),
    ROUTER:             require('./router'            ),
    DASHBOARD:          require('./dashboard'         ),
    SURVEYS:            require('./surveys'           ),
    APP_FEEDBACK:       require('./app-feedback'      ),
    WELCOME_PAGE_MANAGEMENT: require('./welcome-page-management')
});
